import { id, root } from './contact-search';

export const contactSearch = {
  id,
  ...root,
};
